<script>
/* eslint-disable */
</script>
<template>

  <div>
    <modal-layout-top :title="'Filer'" />
    <div class="slider-modal">
      <!-- <vue-media-manager :opts="options"></vue-media-manager> -->
      <!-- <input type="text" id="file-input" ref="file-input"> -->
      <div id="media-manager" ref="media-manager"></div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

import MM from '@/components/external/media-manager/MM'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'

export default {
  name: 'file-viewer-modal',
  components: {
    ModalLayoutTop
  },
  props: {
    id: {
      type: Number,
      required: false
    },
    defaultPath: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      proj: {}
    }
  },
  methods: {
    ...mapActions(
      'projects', ['getById']
    ),
    init () {
      /* eslint-disable no-new, no-unused-vars */
      if (this.id) {
        this.getById(this.id).then(project => {
          this.proj = project
          let that = this
          let listUrl = 'list/' + that.proj.projectCode
          if(this.defaultPath) {
            listUrl += '/' + this.defaultPath
          }
          new MM({
            el: '#media-manager',
            api: {
              baseUrl: `${process.env.ROOT_API}/file/`,
              listUrl: listUrl,
              downloadUrl: `${process.env.ROOT_API}/file/download/` + that.proj.projectCode,  // optional
            },
            multipleSelection: false
          })
        })
      }
    },

    media () {
    },

    manager () {
    }
  },

  created () {
  },

  mounted () {
    this.init()
  }
}
</script>
<style lang="scss">
  .panel.panel-default {
    background-color: transparent;
  }
  .panel-modal{z-index:100;background-color:rgba(0,0,0,.5)}.panel-modal,.panel-modal .panel{position:absolute;top:0;bottom:0;left:0;right:0}.panel-modal .panel{margin:15px;overflow:auto}.panel-modal .panel-heading{font-size:14px;font-weight:700}.panel-modal .panel-body{position:absolute;bottom:0;top:41px;left:0;right:0;overflow:auto}.media-manager .btn{border-radius:0}.mm{position:relative}.mm .animated{animation-duration:.4s}.mm-fixed-height>.panel{position:absolute;top:0;bottom:0;left:0;right:0;margin:0}.mm-fixed-height>.panel>.panel-body{position:absolute;top:0;bottom:0;left:0;right:0;overflow:auto}.mm-fixed-height .mm-content{min-height:250px}.upload-drop-zone{background-color:#f8f8f8;outline:1px dashed #ccc;padding:20px;margin-bottom:15px;outline-offset:-10px;transition:all .4s}.upload-drop-zone.drag-over{background-color:#eee;outline-color:#000}.upload-drop-zone.drag-over .upload-widget-icon{opacity:1}.upload-drop-zone form{text-align:center}.upload-drop-zone label{display:block;cursor:pointer;font-size:1.5em;font-weight:700}.upload-drop-zone label span{font-weight:400}.upload-drop-zone input[type=file]{display:none}.upload-widget-icon{margin:0 auto;opacity:.2;transition:opacity .4s}.upload-status-widget .table-responsive{margin-bottom:15px}.upload-status-widget table{font-size:12px;margin-bottom:0}.upload-status-widget .progress{width:100%;min-width:150px;margin-bottom:0}.medias{margin:-5px -5px 15px}.medias .file{margin:5px}.context-menu{position:absolute;background-color:#fff;box-shadow:0 1px 5px rgba(0,0,0,.5);z-index:100}.context-menu ul{padding-left:0;margin-bottom:0;list-style:none}.context-menu li{display:block}.context-menu li a{display:block;padding:6px 15px;font-weight:400;color:#333;text-decoration:none;white-space:nowrap}.context-menu li a:hover{background-color:#eee}.file{position:relative;float:left;width:70px;height:80px;cursor:pointer;border:2px solid #eee;transition:border-color .4s;overflow:hidden}.file-preview{padding:4px}.file-preview .thumb{width:100%;margin-top:-5px}.file-preview .icon{text-align:center;line-height:48px;font-size:36.92308px}.file-preview .icon .fa{vertical-align:middle}.file-no-title .icon{line-height:68px}.file-title{position:absolute;height:20px;right:0;bottom:0;left:0;overflow:hidden;background-color:#eee;transition:background-color .4s}.file-title h3{color:#000;margin:0 4px;line-height:20px;font-size:11pt;transition:color .4s}.file.selected{border-color:#333}.file.selected .file-title{background-color:#333}.file.selected .file-title h3{color:#fff}.details-widget-content .thumb{max-height:100px}.details-widget-content .icon{line-height:100px;font-size:50px}.details-widget-content .buttons{text-align:right}
  .content ul {
    margin-left: 0 !important;
    margin-top: 0 !important;
  }
  .icon {
      height: 2.5rem;
      width: 3.5rem;
  }
  .content ol {
    list-style-type: none !important;
  }
  .mm .breadcrumb li {
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/FileViewerModal.vue